/* "Adicione também" — comportamento do carrossel de sugestões da sacola.

   O markup vem do servidor (snippets/cart-recommendations.liquid) porque a
   fonte é um metacampo, que só existe no Liquid. Depois de cada mudança do
   carrinho o bloco é buscado de novo pela Section Rendering API — assim as
   sugestões do produto recém-adicionado aparecem e o que entrou na sacola sai
   da lista.

   O "+" adiciona via /cart/add.js e dispara 'buddylab:cart:added', o mesmo
   evento que o global.js escuta para atualizar e abrir a sacola. */
(function () {
  'use strict';

  var SECTION_URL = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  function node() {
    return document.querySelector('[data-cart-recos]');
  }

  /* ---------- carrossel ---------- */

  function step(track) {
    var item = track.querySelector('.crec__item');
    if (!item) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function syncArrows(root) {
    var track = root.querySelector('[data-crec-track]');
    var prev = root.querySelector('[data-crec-prev]');
    var next = root.querySelector('[data-crec-next]');
    if (!track || !prev || !next) return;
    var max = track.scrollWidth - track.clientWidth - 1;
    prev.disabled = track.scrollLeft <= 1;
    next.disabled = track.scrollLeft >= max;
  }

  function bindCarousel(root) {
    var track = root.querySelector('[data-crec-track]');
    if (!track) return;
    var prev = root.querySelector('[data-crec-prev]');
    var next = root.querySelector('[data-crec-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(track) }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(track) }); });
    track.addEventListener('scroll', function () { syncArrows(root); }, { passive: true });
    syncArrows(root);
  }

  /* ---------- adicionar ---------- */

  function addToCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;

    clearTimeout(btn._crecTimer);
    btn.disabled = true;
    btn.classList.remove('is-added', 'is-error');
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add-failed');
        return r.json();
      })
      .then(function () {
        /* O is-loading só sai aqui: entre a resposta e a troca do bloco pela
           Section Rendering API ainda há espera, e o botão não pode voltar a
           parecer clicável nesse intervalo. */
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-added');
        document.dispatchEvent(new CustomEvent('buddylab:cart:added'));
      })
      .catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-error');
        btn._crecTimer = setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
      });
  }

  /* Delegado no document: o bloco é substituído a cada atualização do carrinho,
     então listeners presos aos formulários não sobreviveriam. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-crec-add]')) return;
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- atualização ---------- */

  var pending = false;

  function refresh() {
    var current = node();
    if (!current || pending) return;
    pending = true;

    fetch(SECTION_URL + '?sections=cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('section-failed');
        return r.json();
      })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-cart-recos]');
        var target = node();
        if (!fresh || !target) return;
        target.innerHTML = fresh.innerHTML;
        target.hidden = fresh.hidden;
        bindCarousel(target);
      })
      .catch(function () {
        /* Sugestão é conteúdo acessório: falha silenciosa mantém a sacola usável. */
      })
      .finally(function () {
        pending = false;
      });
  }

  document.addEventListener('buddylab:cart:updated', refresh);
  document.addEventListener('buddylab:cart:added', refresh);

  function init() {
    var root = node();
    if (root) bindCarousel(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
